<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">
        Moderação de valores dos dados
      </h1>
      <div class="row">
        <div class="col-xs-12">
          <list
            ref="listModeration"
            :show-empty="true"
            :title="'Valores para moderar'"
            reportTitle="Moderação de dados"
            api-url="moderacao"
            :fields="listModeration.columns"
            :initial-page="listModeration_pagina"
            :pageCollection="'listModeration'"
          >
            <template slot="custom" slot-scope="props">
              <span v-if="props.rowData.dado_tipo === 'T'">
                <a
                  href="javascript:void()"
                  @click="showModal(props.rowData)"
                  title="Visualize a resposta"
                >
                  <font-awesome-icon
                    :icon="'file-alt'"
                    size="2x"
                  ></font-awesome-icon>
                </a>
              </span>
              <span v-else>
                {{ props.rowData.valor_numerico_anterior }}
              </span>
            </template>

            <template slot="custom_2" slot-scope="props">
              <span v-if="props.rowData.dado_tipo === 'T'">
                <a
                  href="javascript:void()"
                  @click="showModal(props.rowData)"
                  title="Visualize a resposta"
                >
                  <font-awesome-icon
                    :icon="'file-alt'"
                    size="2x"
                  ></font-awesome-icon>
                </a>
              </span>
              <span v-else>
                {{ props.rowData.valor_numerico_atual }}
              </span>
            </template>

            <template slot="rowrender" slot-scope="props">
              <div class="button-wrapper">
                <router-link
                  title="Lista de valores"
                  class="btn btn-primary"
                  :to="{
                    name: 'admin_dado_valor_list',
                    params: { DAD_IDDADO: props.rowData.DAD_IDDADO }
                  }"
                >
                  <font-awesome-icon :icon="'list-ol'"></font-awesome-icon>
                </router-link>
                <button
                  title="Aprovar"
                  type="button"
                  class="btn btn-primary"
                  @click="aprovar(props.rowData)"
                >
                  <font-awesome-icon :icon="'check'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <list
            ref="listApproved"
            :show-empty="true"
            :title="'Valores aprovados nos ultimos 30 dias'"
            reportTitle="Aprovados"
            api-url="moderacao?last_approved=30"
            :fields="listApproved.columns"
            :initial-page="listApproved_pagina"
            :pageCollection="'listApproved'"
          >
            <template slot="custom" slot-scope="props">
              <span v-if="props.rowData.dado_tipo === 'T'">
                <a
                  href="javascript:void()"
                  @click="showModal(props.rowData)"
                  title="Visualize a resposta"
                >
                  <font-awesome-icon
                    :icon="'file-alt'"
                    size="2x"
                  ></font-awesome-icon>
                </a>
              </span>
              <span v-else>
                {{ props.rowData.valor_atual }}
              </span>
            </template>

            <template slot="rowrender" slot-scope="props">
              <div class="button-unique">
                <button
                  title="Reprovar"
                  type="button"
                  class="btn btn-primary"
                  @click="reprovar(props.rowData)"
                >
                  <font-awesome-icon :icon="'times'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}

.button-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: right;
  min-width: 145px;
}

.button-wrapper > button {
  margin-left: 4px;
}

.button-wrapper > button:first-child {
  margin-left: 0px;
}

.button-unique {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  min-width: 145px;
}
</style>

<script>
import list from '@/components/common/DataTable'
import modal from '@/components/common/Modal'
import { request } from '@/request'

export default {
  inject: ['showConfirm'],
  name: 'Moderation',
  data() {
    return {
      listModeration: {
        columnID: 'id',
        columns: [
          {
            name: 'dado_nome',
            title: 'Nome',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: 'user',
            title: 'Usuário',
            dataClass: 'align-middle',
            filterable: true,
            callback: ({ USU_NMUSUARIO, username }) =>
              `<span title="${USU_NMUSUARIO}">${username}</span>`
          },
          {
            name: 'data_valor',
            title: 'Data',
            dataClass: 'align-middle',
            filterable: true,
            callback: date => new Date(date).toLocaleDateString()
          },
          {
            name: '__slot:column_custom',
            title: 'Valor Anterior',
            titleClass: 'text-center col-md-2',
            dataClass: 'text-center'
          },
          {
            name: '__slot:column_custom_2',
            title: 'Valor Atual',
            titleClass: 'text-center col-md-2',
            dataClass: 'text-center'
          },
          {
            name: '__slot:actions',
            title: 'Ações',
            titleClass: 'text-center col-md-2',
            dataClass: 'text-center'
          }
        ]
      },
      listApproved: {
        columnID: 'id',
        columns: [
          {
            name: 'dado_nome',
            title: 'Nome',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: '__slot:column_custom',
            title: 'Valor',
            titleClass: 'text-center col-md-2',
            dataClass: 'text-center'
          },
          {
            name: 'moderate_at',
            title: '<span title="Data da moderação">Data</span>',
            dataClass: 'align-middle',
            filterable: true,
            callback: date => new Date(date).toLocaleDateString()
          },
          {
            name: 'user_moderador',
            title: '<span title="Usuário que moderou">Usuário</span>',
            dataClass: 'align-middle',
            filterable: true,
            callback: ({ USU_NMUSUARIO, username }) =>
              `<span title="${USU_NMUSUARIO}">${username}</span>`
          },
          {
            name: '__slot:actions',
            title: 'Ações',
            titleClass: 'text-center col-md-2',
            dataClass: 'text-center'
          }
        ]
      }
    }
  },
  components: {
    list,
    modal
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  computed: {
    listModeration_pagina: {
      get() {
        return this.$store.state.vuetableState.listModeration.pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'listModeration',
          value: value
        })
      }
    },
    listApproved_pagina: {
      get() {
        return this.$store.state.vuetableState.listApproved.pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'listApproved',
          value: value
        })
      }
    }
  },
  methods: {
    aprovar({ id }) {
      var config = {
        title: 'Alerta',
        question: true,
        yes: async () => {
          try {
            await request.put(`moderacao/${id}`)
            this.$toastr.s('Valor aprovado com sucesso.')
            this.consultar()
          } catch (error) {
            this.$toastr.e(
              'Tivemos um problema técnico para aprovar o valor, por favor tente daqui alguns minutos.'
            )
          }
        }
      }
      this.showConfirm('Tem certeza que deseja aprovar este valor?', config)
    },
    reprovar({ id }) {
      var config = {
        title: 'Alerta',
        question: true,
        yes: async () => {
          try {
            await request.delete(`moderacao/${id}`)
            this.$toastr.s('Valor reprovado com sucesso.')
            this.consultar()
          } catch (error) {
            this.$toastr.e(
              'Tivemos um problema técnico para reprovar o valor, por favor tente daqui alguns minutos.'
            )
          }
        }
      }
      this.showConfirm('Tem certeza que deseja reprovar este valor?', config)
    },
    consultar() {
      this.$nextTick(function() {
        this.$refs.listModeration.refresh()
        this.$refs.listApproved.refresh()
      })
    },
    showModal({
      valor_texto_anterior,
      valor_texto_atual,
      observacao_atual,
      observacao_anterior
    }) {
      var config = {
        title: 'Respostas',
        question: false
      }

      const templateObsAtual = observacao_atual
        ? `<h6><b>Observação:</b>${observacao_atual}</h6>`
        : ''
      const templateObsAnterior = observacao_anterior
        ? `<h6><b>Observação:</b>${observacao_anterior}</h6>`
        : ''

      const htmlContent = `<div class="form-group">
                              <label class="control-label">
                                Atual
                              </label> 
                              <textarea readonly rows="7" class="form-control" aria-required="true" aria-invalid="false">
                              ${valor_texto_atual}
                              </textarea>
                              ${templateObsAtual}
                            </div>
                            <div class="form-group">
                              <label class="control-label">
                                Anterior
                              </label> 
                              <textarea readonly rows="7" class="form-control" aria-required="true" aria-invalid="false">
                              ${valor_texto_anterior}
                              </textarea>
                              ${templateObsAnterior}
                            </div>`

      this.showConfirm(htmlContent, config)
    }
  }
}
</script>

<style>
.truncate-text-70 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/dados/Moderation.vue